/* eslint-disable import/extensions */

import React from 'react'

import { Card, Typography, Box, Divider, Button } from '@material-ui/core'

import useSummaryPage from './useSummaryPage'

import AddressSummary from '~/address/components/AddressSummary'
import { AddressType } from '~/address/models/address.model'
import BundlesSummary from '~/bundles/components/BundlesSummary/BundlesSummary'
import ContactForm from '~/customer/components/ContactForm/ContactForm'
import CustomerSummary from '~/customer/components/CustomerSummary/CustomerSummary'
import LegalTexts from '~/legal/components/LegalTexts/LegalTexts'
import LineSummary from '~/line/components/LineSummary/LineSummary'
import BillingSummary from '~/payments/billing/components/BillingSummary'
import PATHS from '~/router/paths'
import TariffSummary from '~/tariff/components/TariffSummary/TariffSummary'

function SummaryLine({
  title,
  id,
  addressType,
  isOffline,
}: {
  title: string
  id: string
  addressType: AddressType
  isOffline: boolean
}) {
  return (
    <Box mb={6}>
      <Card elevation={5}>
        <Box py={5} px={6}>
          <Typography variant="h3">{title}</Typography>
        </Box>
        <Divider />
        <Box px={6} pb={6}>
          <Box pt={4}>
            <TariffSummary id={id} />
            <Box mt={7}>
              <Divider className="dotted" />
            </Box>
          </Box>
          <BundlesSummary id={id} />
          <Box pt={4}>
            <LineSummary id={id} />
          </Box>
          {!isOffline && (
            <Box>
              <Box mt={7} mb={4}>
                <Divider className="dotted" />
              </Box>
              <AddressSummary id={id} addressType={addressType} />
            </Box>
          )}
        </Box>
      </Card>
    </Box>
  )
}

export default function SummaryPage() {
  const {
    lines,
    title,
    isOffline,
    isPostpaid,
    enabled,
    setShouldCreatePreContract,
    setIsLegalOpen,
    isLegalOpen,
    onConfirmLegal,
    history,
  } = useSummaryPage()

  return (
    <div data-hook="summary-page">
      {lines &&
        Object.keys(lines).map((line) => (
          <SummaryLine
            key={line}
            title={title}
            id={line}
            addressType={AddressType.SIM}
            isOffline={isOffline}
          />
        ))}
      <Box mb={6}>
        <Card elevation={5}>
          <Box py={5} px={6}>
            <Typography variant="h3">Datos del titular</Typography>
          </Box>
          <Divider />
          <Box px={6} pb={6}>
            <CustomerSummary />
          </Box>
        </Card>
      </Box>

      {isPostpaid && (
        <Box mb={6}>
          <Card elevation={5}>
            <BillingSummary />
          </Card>
        </Box>
      )}

      <Box mt={6}>
        <ContactForm />
        <Box mt={6}>
          <Button
            disabled={!enabled}
            data-hook="submit-btn"
            type="submit"
            variant="contained"
            color="secondary"
            onClick={() => (isOffline ? setShouldCreatePreContract(true) : setIsLegalOpen(true))}
          >
            Confirmar oferta
          </Button>
          <Box mx={4} display="inline-block">
            <Button
              data-hook="back-btn"
              variant="outlined"
              color="secondary"
              onClick={() =>
                history.push({ pathname: isPostpaid ? PATHS.BILLING : PATHS.OFFER_SETUP })
              }
            >
              Atrás
            </Button>
          </Box>
        </Box>
      </Box>
      <LegalTexts
        isOpen={isLegalOpen}
        onConfirm={onConfirmLegal}
        onClose={() => setIsLegalOpen(false)}
      />
    </div>
  )
}
